import { render, staticRenderFns } from "./ULabel.vue?vue&type=template&id=6671cc70&"
import script from "./ULabel.vue?vue&type=script&lang=js&"
export * from "./ULabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports